<template lang="pug">
  #app
    nav.navbar.is-link
      .navbar-brand
        a.navbar-item(href="https://docent.blink.nl/nederlandsvo-a")
          img.logo(:src="baseUrl + 'img/blink.png'")
        a.navbar-item(href="/") VO Kerndoelen en Eindtermen
      .navbar-start
        .navbar-item
          a.button.is-light(@click="searching = true") zoeken
       
      .navbar-end
        .navbar-item.has-dropdown.is-hoverable
          .navbar-link Blink Nederlands
          .navbar-dropdown
            .navbar-item Blink Nederlands
            span.navbar-item.is-disabled(aria-disabled="true") Blink Engels

        .navbar-item.has-dropdown.is-hoverable
          .navbar-link {{content.tree.title}}
          .navbar-dropdown
            a.navbar-item(@click="useContent('plot26.jaar1')") Jaar 1
            span.navbar-item.is-disabled(aria-disabled="true")
              | Jaar 2
              span.later  · volgt later
            .navbar-divider
            span.navbar-item.is-disabled(aria-disabled="true")
              | Jaar 3 HAVO/VWO
              span.later  · volgt later
            span.navbar-item.is-disabled(aria-disabled="true")
              | Jaar 3 VMBO
              span.later  · volgt later
        .navbar-item.has-dropdown.is-hoverable.is-right
          .navbar-link {{goal.tree.title}}
          .navbar-dropdown
            a.navbar-item(@click="useGoal(kerndoelenNL)") Kerndoelen Nederlands (2026)
            span.navbar-item.is-disabled(aria-disabled="true") Referentiekader Taal (Meijerink)
            span.navbar-item.is-disabled(aria-disabled="true") 21e eeuwse vaardigheden (SLO)
        
    #rest.columns
      .column.is-one-quarter
        .head
          .methode(v-if="content.tree.image")
            img(:src="content.tree.image")
          .fltrs(v-if="filters.length > 0")
            p gefilterd op
            .tag(v-for="f in filters" :style="{'background-color': f.color}")
              | {{f.title}}
              a.is-small.delete(@click="f.active = false")
        .bod
          .rows
            Row(:node="content.tree" :target="goal" @click="handleRowClick")  
      .column.trgt
        TableTreeHeader(:node="goal.tree" :papa="{width: goal.tree.totalWidth, offset: 0}" @select="handleGoalSelect")  
    ContentModal(:row="detailRow" :target="goal.tree" :targets="targets" :filter="detailGoalFilter" v-if="detailRow" @close="detailRow = null" @delta="handleDelta" @activate="handleActivation")
    SearchModal(v-if="searching" @close="searching = false" :goal="goal" @select="handleGoalClick")
</template>

<script>
let _ = require('lodash')
let Chroma = require('chroma-js')

import {methode as plot1} from './data/plot26.js'
import {methode as plot2} from './data/plot26-2.js'
import {methode as plot3} from './data/plot26-3.js'
import {doel} from './data/meijerink.js'
import {buildStructure} from './data/helpers.js'
import {goal21} from './data/21.js'
import {doelNL} from './data/kerndoelen-nl.js'

import Row from './components/Row.vue'
import TableTreeHeader from './components/TableTreeHeader.vue'
import ContentDetails from './components/ContentDetails.vue'
import GoalDetails from './components/GoalDetails.vue'
import ContentModal from './components/ContentModal.vue'
import SearchModal from './components/SearchModal.vue'

const methodes = {
  plot26: {
    jaar1: buildStructure(plot1),
    jaar2: buildStructure(plot2),
    hv: {

      jaar3: buildStructure(plot3)
    },
    vmbo: {

 
      jaar3: buildStructure(_.cloneDeep(plot3))
    }
  }
}


methodes.plot26.vmbo.jaar3.tree.title = 'Blink Nederlands Jaar 3 VMBO'

export default {
  name: 'app',
  components: {
    Row, TableTreeHeader, ContentDetails, GoalDetails, ContentModal, SearchModal
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      content: methodes.plot26.jaar1,
      goal: buildStructure(doelNL),
      detailRow: null,
      detailGoal: null,
      detailGoalFilter: null,
      goal21: buildStructure(goal21),
      meierink: buildStructure(doel),
      kerndoelenNL: buildStructure(doelNL),
      searching: false
    }
  },
  computed: {
    targets() {
      return [this.kerndoelenNL, this.meierink, this.goal21 ]
    },
    filters() {
      return _.filter(this.goal.rows, (r) => r.active)
    }
  },
  methods: {
    handleRowClick(data) {
      console.log('so you click on row', data)
      this.detailRow = data.row
      this.detailGoalFilter = data.cell
    },
    handleGoalSelect(goal) {
      this.detailGoal = goal
    },
    handleGoalClick(goal) {
      this.searching = false
      if (goal) {
        goal.active = true
      }
    },
    useGoal(g) {
      this.goal = g
    },
    useContent(path) {
      this.content = _.get(methodes, path)
    },
    select(g, flag) {
      if (g.parent && g.parent.isLeaf) {
        g.parent.selected = flag
      } else {
        g.selected = flag
      }
    },
    handleDelta(delta) {
      //move to next or prev lesson
      if (this.detailRow) {
        const idx = this.content.rows.indexOf(this.detailRow)
        const newidx = idx + delta
        if (newidx < this.content.rows.length) {
          this.detailRow = this.content.rows[newidx]
        }
      }
    },
    handleActivation(g) {
      //not yet working
      //this.detailRow = null
      console.log('handling activation for', g)
      if (g) {
        //g.active = true
      }
    }
  }
}
</script>

<style scoped>
body {
  
}
#app {
  
  width: 100%;
}
.navbar {
  z-index: 2000;
}
.navbar .logo {
  transition: all 1s ease;
}
.navbar:hover .logo {
  filter: invert(100%);

}
.modal {
  z-index: 5000;
}
.suggestion {
  cursor: pointer;
}
.suggestion:hover {
  background-color: #efefef;
}
.goal {
  padding: 4px;
  border: 1px solid #666;
  border-radius: 4px;
  display: inline-block;
  margin-right: 4px;
}
.methode {
  position: absolute;
  right: 0; left: 0;
  text-align: center;
  
}
.logo {
}
#rest {
  position: absolute;
  top: 52px; left: 0; bottom: 0; right: 24px;
  margin: 0;
}
.column {
  padding: 0;
}
.column .head {
  height: 240px;
  position: relative;
}
.column .bod {
}
.trgt {
  position: relative;
  height: 500vh;

  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
}
.columns {
  margin: 0 !important;
}
.rows {
  position: absolute;
  width: 100%;
}
.fltrs {
  position: absolute;
  bottom: 4px;
  right: 4px;
}
.fltrs p {
  text-align: right;
}
.fltrs .tag {
  margin-right: 4px;
}
.navbar-item.is-disabled {
  color: #999;
  cursor: default;
  pointer-events: none;
}
.navbar-item.is-disabled .later {
  font-size: 0.8em;
  font-style: italic;
  color: #bbb;
}


</style>
